<script setup lang="ts">
import { gaiaNeutral, gaiaShadow } from '../themes/tokens';

/**
 * Being a component is the point, not just the saving. A popover teleports its
 * content to <body>, and `v-bind()` in scoped CSS declares its variables on the
 * component's root element: written inline in a host's template, the panel ends
 * up outside the tree those variables live on and every token resolves to
 * nothing — a see-through menu with the page reading through it. Here the panel
 * *is* the root, so the variables travel with it wherever the popover puts it.
 */
const props = defineProps({
  /** Fixed measure. Omit to size to the content. */
  width: {
    type: String,
    default: undefined,
  },
});

const surface = gaiaNeutral.surface;
// `menu`, not `panel`: an anchored list is short-lived, and `panel` leads with
// a hard 3px ring meant to hold a workspace off the page — beside a menu's own
// edge that ring reads as a second, smudged outline.
const menuShadow = gaiaShadow.menu;
</script>

<template>
  <div class="gaia-menu-surface" :style="{ width: props.width }">
    <slot />
  </div>
</template>

<style scoped>
.gaia-menu-surface {
  display: flex;
  flex-direction: column;
  padding: 6px;
  border-radius: 10px;
  background: v-bind(surface);
  box-shadow: v-bind(menuShadow);
}
</style>
